module.exports = __webpack_public_path__ + "img/8.28cffaa2.jpg";